import permissions from "app/permissions";
import { getPermissions } from "auth/security/securityUtils";
import {
  List,
  TextField,
  EditButton,
  ShowButton,
  Datagrid,
  SimpleList,
  TopToolbar,
  CreateButton,
  FunctionField,
  SelectInput,
} from "react-admin";
import { checkPermission } from "server/security/utils";
import { MOBILE_BREAKPOINT } from "utils/constants";
import { useMediaQuery } from "@mui/material";
import { EmptyList } from "server/components";
import { settings } from "app";
import { BuildingsExporter } from "./XlsxExporter";
import { ExportXlsButton } from "features/ExportXlsxButton";
import { MobileListRow } from "features/MobileListRow";
import { BuildingsIsExternalChoices } from "utils/choices";

const filters = [
  <SelectInput
    source="isExternal"
    label="Външна сграда"
    choices={BuildingsIsExternalChoices}
    defaultValue={false}
    alwaysOn
  />,
];

const ListBuildings = () => {
  const isMobile = useMediaQuery(MOBILE_BREAKPOINT);
  const userPermissions = getPermissions();

  const ListActions = hasCreate => {
    return (
      <TopToolbar>
        {hasCreate && <CreateButton />}
        <ExportXlsButton exporter={BuildingsExporter} />
      </TopToolbar>
    );
  };

  return (
    <List
      title="Сгради"
      actions={<ListActions hasCreate={checkPermission(userPermissions, permissions.canCreateBuildings)} />}
      filters={filters}
    >
      {isMobile ? (
        <SimpleList
          empty={<EmptyList />}
          linkType={false}
          sx={settings.style.mobileList}
          primaryText={record => (
            <MobileListRow fields={[{ label: "Име на български език", value: record.nameBg }]} />
          )}
          secondaryText={record => (
            <div>
              <MobileListRow fields={[{ label: "Име на английски език", value: record.nameEn }]} />
              <MobileListRow fields={[{ label: "Адрес", value: record.address }]} />
              <MobileListRow fields={[{ label: "Географска ширина", value: record.latitude }]} />
              <MobileListRow fields={[{ label: "Географска дължина", value: record.longitude }]} />
              <MobileListRow
                fields={[{ label: "Външна сграда", value: record.isExternal ? "Да" : "Не" }]}
              />
            </div>
          )}
          tertiaryText={() => (
            <>
              {checkPermission(getPermissions(), permissions.canUpdateBuildings) && <EditButton label="" />}
              <ShowButton label="" />
            </>
          )}
        />
      ) : (
        <Datagrid
          bulkActionButtons={false}
          rowClick={false}
        >
          <TextField
            source="nameBg"
            label="Име на български език"
            sortable={false}
          />
          <TextField
            source="nameEn"
            label="Име на английски език"
            sortable={false}
          />
          <TextField
            source="address"
            label="Адрес"
            sortable={false}
          />
          <TextField
            source="latitude"
            label="Географска ширина"
            sortable={false}
          />
          <TextField
            source="longitude"
            label="Географска дължина"
            sortable={false}
          />
          <FunctionField
            source="isExternal"
            label="Външна сграда"
            render={record => (record.isExternal ? "Да" : "Не")}
            sortable={false}
          />
          {checkPermission(getPermissions(), permissions.canUpdateBuildings) && <EditButton />}
          <ShowButton />
        </Datagrid>
      )}
    </List>
  );
};
export default ListBuildings;
